
import { DisplayLayerInfo, LayerManagementProps } from "./types";
import { LayerRow } from "./LayerRow";
import { cn } from "@/lib/utils";

interface LayerPanelProps extends LayerManagementProps {
  className?: string;
  compact?: boolean;
}

export function LayerPanel({ 
  layers, 
  onToggleVisibility, 
  onRename,
  onBringForward,
  onSendBackward,
  className,
  compact = false
}: LayerPanelProps) {
  if (layers.length === 0) {
    return (
      <div className={cn("p-6 text-center text-muted-foreground", className)}>
        No layers available
      </div>
    );
  }

  // The layers are already ordered by the useLayerManagement hook
  return (
    <div className={cn("space-y-1", compact ? "p-0" : "p-2", className)}>
      {layers.map((layer) => (
        <LayerRow
          key={layer.id}
          layer={layer}
          onToggleVisibility={onToggleVisibility}
          onRename={onRename}
          onBringForward={onBringForward}
          onSendBackward={onSendBackward}
        />
      ))}
    </div>
  );
}
